export class Department {
  constructor(department) {
    this.id = department.id;
    this.name = department.name;
    this.createdAt = new Date(department.createdAt);
    this.updatedAt = new Date(department.updatedAt);
  }
}